import {
    loadSelectoptionList,
    selectOption,
} from '../actions/selectQuestionAction';
import { updateConsultRequestFields, updateQualificationResponses } from '../../services/customFieldService';
import {
    appUrl,
    form,
    leadTextId,
    leadInfo,
    listDataQuestion,
    listNamePageQuestion,
    nameScreenDynamic,
    progressQuestion,
    setListDataQuestion,
    setListNamePageQuestion,
    setNameScreenDynamic,
    setProgressQuestion,
    questionnaireFields,
    questionnaireFormId,
    clearQuestionnaireContext,
} from '../../utils/variables';
import { clearCustomFields, loadCustomFields } from '../actions/consultActions';
import { customFeildGoBackAnimationHandler, navigate, setSessionEndStepSentForLeadId, setIsDisqualified } from './movePages';
import { toastError } from '../../views/components/error';
import { navigateToNextPage } from './navigationHelper';
import { evaluateDisqualifier, shouldDisqualifyNow } from '../../utils/disqualifierEvaluator';
import { SCREEN } from '../../utils/constants';
import { updateLeadStep } from '../../services/leadServices';
import { textQuestionListener } from './textQuestionListener';
import { checkboxQuestionListener } from './checkboxQuestionListener';
import { dateQuestionListener } from './dateQuestionListener';
import { textAreaQuestonListener } from './textareaQuestionListener';
import { numberQuestionListener } from './numberQuestionListener';
import { heightQuestionListener } from './heightQuestionListener';

export function selectQuestionListener() {
    const itemId = nameScreenDynamic.split('--')[1];
    const fields = questionnaireFields?.length
        ? questionnaireFields
        : form?.form?.custom_fields ?? [];
    const customField = fields.find((custom) => custom && custom.id == itemId);
    const isMultiSelect = customField?.type === 'multi_select';
    const optionsOrAnswers = customField?.options ?? customField?.answers;

    // check has data
    if (
        listNamePageQuestion.find((name) => name === nameScreenDynamic) &&
        listDataQuestion[itemId]
    ) {
        const savedValue = listDataQuestion[itemId];
        if (isMultiSelect) {
            const selectedValues = JSON.parse(savedValue);
            selectedValues.forEach(value => selectOption(value, true));
        } else {
            selectOption(savedValue);
        }
        document
            .querySelector(`${nameScreenDynamic} .selectContinue__btn`)
            ?.classList.remove('disabled');
        document
            .querySelector(
                `${nameScreenDynamic} .selectContinue__btn .loading__wrapper`
            )
            ?.classList.add('hidden');
        const loaderIcon = document.querySelector(
            `${nameScreenDynamic} .loader__icon`
        );
        if (loaderIcon) {
            loaderIcon.innerHTML = '';
            loaderIcon.insertAdjacentHTML(
                'beforeend',
                `<i class="ri-arrow-right-line"></i>`
            );
        }
        return;
    } else {
        loadSelectoptionList(optionsOrAnswers);
    }

    /* on select option*/
    document.querySelectorAll(`${nameScreenDynamic} .option`).forEach((i) => {
        i.addEventListener('click', () => {
            const value = i.getAttribute('data-option');
            selectOption(value, isMultiSelect);
        });
    });

    /* On click Back button */
    document
        .querySelector(`${nameScreenDynamic} .selectQuestionBack__btn`)
        ?.addEventListener('click', () => {
            const idx = listNamePageQuestion.findIndex(
                (l) => l === nameScreenDynamic
            );
            if (idx > 0) {
                setProgressQuestion({
                    ...progressQuestion,
                    currentQuestion: progressQuestion.currentQuestion - 1,
                    progress: (((progressQuestion.currentQuestion - 1) / progressQuestion.total) * 100)
                });
                customFeildGoBackAnimationHandler(`${nameScreenDynamic}`);
                setNameScreenDynamic(listNamePageQuestion[idx - 1]);

                if (
                    nameScreenDynamic.includes('text') &&
                    !nameScreenDynamic.includes('textarea')
                ) {
                    textQuestionListener();
                } else if (nameScreenDynamic.includes('checkbox')) {
                    checkboxQuestionListener();
                } else if (nameScreenDynamic.includes('select')) {
                    selectQuestionListener();
                } else if (nameScreenDynamic.includes('date')) {
                    dateQuestionListener();
                } else if (nameScreenDynamic.includes('textarea')) {
                    textAreaQuestonListener();
                } else if (nameScreenDynamic.includes('number')) {
                    numberQuestionListener();
                } else if (nameScreenDynamic.includes('height')) {
                    heightQuestionListener();
                }
            } else {
                customFeildGoBackAnimationHandler(`${nameScreenDynamic}`);
            }
        });

    /* On click enter */
    const screenSelect = document.querySelector(
        `${nameScreenDynamic} .screen--select`
    );

    if (screenSelect) {
        screenSelect.addEventListener('keydown', (event) => {
            if (
                event.key === 'Enter' &&
                !document
                    .querySelector(`${nameScreenDynamic} .selectContinue__btn`)
                    .classList.contains('disabled')
            ) {
                document
                    .querySelector(`${nameScreenDynamic} .selectContinue__btn`)
                    .click();
            }
        });
    }

    /* on click Continue after select option */
    const btnSelectElement = document.querySelector(
        `${nameScreenDynamic} .selectContinue__btn`
    );
    btnSelectElement.addEventListener('click', async () => {
        if (!listNamePageQuestion.find((list) => list === nameScreenDynamic)) {
            listNamePageQuestion.push(nameScreenDynamic);
        }
        setListNamePageQuestion(listNamePageQuestion);
        document
            .querySelector(`${nameScreenDynamic} .selectContinue__btn`)
            .classList.add('disabled');
        document
            .querySelector(
                `${nameScreenDynamic} .selectContinue__btn .loading__wrapper`
            )
            ?.classList.remove('hidden');
        const loaderIcon = document.querySelector(
            `${nameScreenDynamic} .loader__icon`
        );
        if (loaderIcon) {
            loaderIcon.innerHTML = '';
            loaderIcon.insertAdjacentHTML(
                'beforeend',
                `<img src="${appUrl}/assets/icons/rolling.png" />`
            );
        }
        let value;
        if (isMultiSelect) {
            const selectedValues = Array.from(
                document.querySelectorAll(`${nameScreenDynamic} .option__checkbox.is-selected`)
            ).map(el => el.getAttribute('data-option'));

            value = JSON.stringify(selectedValues);
        } else {
            value = document
                .querySelector(`${nameScreenDynamic} .option__checkbox.is-selected`)
                .getAttribute('data-option');
        }

        const item = nameScreenDynamic.split('--')[1];
        const answersWithCurrent = { ...listDataQuestion, [item]: value };
        listDataQuestion[item] = value;
        setListDataQuestion(listDataQuestion);
        const fields = questionnaireFields?.length
            ? questionnaireFields
            : form?.form?.custom_fields ?? [];
        const currentField = fields.find((f) => f && f.id == item);
        const minDisqualifiers = form?.appointment_channel?.min_disqualifier_matches ?? form?.consult_min_disqualifier_matches ?? 1;
        if (currentField && evaluateDisqualifier(currentField, value) && shouldDisqualifyNow(fields, answersWithCurrent, minDisqualifiers)) {
            try {
                const fieldLabels = {};
                const sourceFields = questionnaireFields?.length ? questionnaireFields : (form?.form?.custom_fields ?? []);
                sourceFields.forEach((f) => { if (f && f.id) fieldLabels[f.id] = (f.label || f.title || 'Custom field'); });
                const formId = questionnaireFormId ?? form?.form?.id;
                if (typeof formId === 'string' && formId.startsWith('ac-')) {
                    const acId = parseInt(formId.replace(/^ac-/, ''), 10);
                    await updateQualificationResponses(leadTextId, acId, listDataQuestion, fieldLabels);
                } else {
                    await updateConsultRequestFields(leadTextId, listDataQuestion, fieldLabels);
                }
            } catch (_) { /* save best-effort */ }
            if (leadInfo?.id) {
                await updateLeadStep(leadInfo.id, 'disqualified', 'true');
                setSessionEndStepSentForLeadId(leadInfo.id);
            }
            document.querySelector(`${nameScreenDynamic} .selectContinue__btn`)?.classList.remove('disabled');
            document.querySelector(`${nameScreenDynamic} .selectContinue__btn .loading__wrapper`)?.classList.add('hidden');
            const loaderIcon = document.querySelector(`${nameScreenDynamic} .loader__icon`);
            if (loaderIcon) { loaderIcon.innerHTML = ''; loaderIcon.insertAdjacentHTML('beforeend', '<i class="ri-arrow-right-line"></i>'); }
            clearCustomFields();
            clearQuestionnaireContext();
            setIsDisqualified(true);
            navigate(SCREEN.THE_END);
            return;
        }
        const formId = questionnaireFormId ?? form?.form?.id;
        let idx = fields.findIndex(
            (custom) => custom && custom.id == nameScreenDynamic.split('--')[1]
        );
        if (idx == fields.length - 1) {
            try {
                const fieldLabels = {};
                const sourceFields = questionnaireFields?.length ? questionnaireFields : (form?.form?.custom_fields ?? []);
                sourceFields.forEach((f) => { if (f && f.id) fieldLabels[f.id] = (f.label || f.title || 'Custom field'); });
                if (typeof formId === 'string' && formId.startsWith('ac-')) {
                    const acId = parseInt(formId.replace(/^ac-/, ''), 10);
                    await updateQualificationResponses(leadTextId, acId, listDataQuestion, fieldLabels);
                } else {
                    await updateConsultRequestFields(leadTextId, listDataQuestion, fieldLabels);
                }
                document
                    .querySelector(`${nameScreenDynamic} .selectContinue__btn`)
                    ?.classList.remove('disabled');
                document
                    .querySelector(
                        `${nameScreenDynamic} .selectContinue__btn .loading__wrapper`
                    )
                    ?.classList.add('hidden');
                const loaderIcon = document.querySelector(
                    `${nameScreenDynamic} .loader__icon`
                );
                if (loaderIcon) {
                    loaderIcon.innerHTML = '';
                    loaderIcon.insertAdjacentHTML(
                        'beforeend',
                        `<i class="ri-arrow-right-line"></i>`
                    );
                }
                clearCustomFields();
                clearQuestionnaireContext();
                navigateToNextPage();

            } catch (error) {
                toastError(error.response?.data?.message);
            }
        } else {
            setProgressQuestion({
                ...progressQuestion,
                currentQuestion: progressQuestion.currentQuestion + 1,
                progress: (((progressQuestion.currentQuestion + 1) / progressQuestion.total) * 100)
            });
            loadCustomFields(fields[idx + 1]);
        }
    });
}
